// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-selectors-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.checkbox-container {
  margin-left: 40px;
  position: relative;
}

.schedule-checkbox {
  margin-top: 10px;
  margin-right: 10px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: relative;
}

.checkbox-label_1 {
  position: absolute;
  top: -25px;
  left: -40px;
  z-index: 1;
  color: #a2a2a2;
}

.checkbox-label_2 {
  position: absolute;
  top: -25px;
  left: 40px;
  z-index: 1;
  color: #a2a2a2;
}

@media screen  and (max-width: 1513px) and (min-width: 913px){
  .schedule-checkbox {
    margin-top: 60px;
  }

  .checkbox-label_1 {
    margin-top: 50px;
    left:-22%;
  }

  .checkbox-label_2 {
    margin-top: 50px;
    left:98%;
  }
}

@media screen  and (max-width: 910px) {
  .schedule-selectors-container {
    flex-direction: column;
  }

  .checkbox-container {
    margin-top: 40px;
    margin-left: 0;
    display: flex;
    justify-content: center;
  }

  .checkbox-label_1 {
    left: 30%;
  }

  .checkbox-label_2 {
    left: 50%;
  }

  .schedule-checkbox {
    margin-top: 3px;
    margin-right: 5px;
    width: 20px;
    height: 20px;
  }
}

@media screen  and (max-width: 520px) {
  .schedule-selectors-container {
    flex-direction: column;
  }

  .checkbox-container {
    margin-top: 40px;
    margin-left: 0;
    display: flex;
    justify-content: center;
  }

  .checkbox-label_1 {
    left: 30%;
  }

  .checkbox-label_2 {
    left: 50%;
  }

  .schedule-checkbox {
    margin-top: 3px;
    margin-right: 5px;
    width: 20px;
    height: 20px;
  }
}

@media screen  and ( max-width: 420px) {
  .checkbox-label_1 {
    left: 25%;
  }

  .checkbox-label_2 {
    left: 50%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Schedule/ScheduleComponents/ScheduleSelectors/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".schedule-selectors-container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.checkbox-container {\n  margin-left: 40px;\n  position: relative;\n}\n\n.schedule-checkbox {\n  margin-top: 10px;\n  margin-right: 10px;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  position: relative;\n}\n\n.checkbox-label_1 {\n  position: absolute;\n  top: -25px;\n  left: -40px;\n  z-index: 1;\n  color: #a2a2a2;\n}\n\n.checkbox-label_2 {\n  position: absolute;\n  top: -25px;\n  left: 40px;\n  z-index: 1;\n  color: #a2a2a2;\n}\n\n@media screen  and (max-width: 1513px) and (min-width: 913px){\n  .schedule-checkbox {\n    margin-top: 60px;\n  }\n\n  .checkbox-label_1 {\n    margin-top: 50px;\n    left:-22%;\n  }\n\n  .checkbox-label_2 {\n    margin-top: 50px;\n    left:98%;\n  }\n}\n\n@media screen  and (max-width: 910px) {\n  .schedule-selectors-container {\n    flex-direction: column;\n  }\n\n  .checkbox-container {\n    margin-top: 40px;\n    margin-left: 0;\n    display: flex;\n    justify-content: center;\n  }\n\n  .checkbox-label_1 {\n    left: 30%;\n  }\n\n  .checkbox-label_2 {\n    left: 50%;\n  }\n\n  .schedule-checkbox {\n    margin-top: 3px;\n    margin-right: 5px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n@media screen  and (max-width: 520px) {\n  .schedule-selectors-container {\n    flex-direction: column;\n  }\n\n  .checkbox-container {\n    margin-top: 40px;\n    margin-left: 0;\n    display: flex;\n    justify-content: center;\n  }\n\n  .checkbox-label_1 {\n    left: 30%;\n  }\n\n  .checkbox-label_2 {\n    left: 50%;\n  }\n\n  .schedule-checkbox {\n    margin-top: 3px;\n    margin-right: 5px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n@media screen  and ( max-width: 420px) {\n  .checkbox-label_1 {\n    left: 25%;\n  }\n\n  .checkbox-label_2 {\n    left: 50%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
